import { Button, styled } from '@mui/material';

export const ChooseFileButton = styled(Button)`
  text-transform: unset;
  font-size: ${({ theme }) => theme.typography.body2.fontSize};
  font-weight: ${({ theme }) => theme.typography.h1.fontWeight};

  ${({ theme }) => theme.breakpoints.up('md')} {
    font-size: ${({ theme }) => theme.typography.body1.fontSize};
  }

  &:hover {
    background-color: ${({ theme }) => theme.palette.secondary.light};
  }
  &.MuiButtonBase-root.MuiButton-root {
    height: 100%;
  }
` as typeof Button;
